<template>
  <v-card class="rounded-lg px-5 mt-5 shadow-custom info-active d-flex flex-column" :height="height" v-bind="$attrs" v-on="$listeners">
    <v-card-text>
      <v-row>
        <v-col cols="11" class="pl-0">
          <p class="headline black--text my-1">
            <strong>{{ title }}</strong>
          </p>
          <p class="primary--text" v-if="current_user.is_super_admin">(Kode: {{ item.kode | toUppercase }})</p>
          <div class="py-2">
            <span
              v-if="!current_user.is_super_admin && !isKelola && item.kode !== 'paud' && item.kelasenrol.length > 0"
              class="green--text green lighten-4 pa-2 rounded-lg text-body-1"
              >Terdaftar</span
            >
            <span
              v-if="!current_user.is_super_admin && !isKelola && item.kode !== 'paud' && item.kelasenrol.length == 0"
              class="grey--text grey lighten-4 pa-2 rounded-lg text-body-1"
              >Tidak Terdaftar</span
            >
          </div>

          <template v-if="item.id !== 5"> </template>
          <template v-else> </template>
        </v-col>
        <v-col cols="1" v-if="current_user.is_super_admin && isKelola" style="z-index:1">
          <m-menu right class="clearfix" style="float: right; z-index: 10" :items="more_menu" :object="item" />
        </v-col>
      </v-row>
    </v-card-text>

    <div :class="[item.is_tutup ? 'card-non-active' : '', 'd-none d-sm-flex']">
      <v-img
        fluid
        style="position: absolute; bottom: 0px; right: 0px; max-width: 250px"
        :src="logo ? logo : 'https://cdn.siap.id/s3/simpkb/asset img/guru-praktik-baik/sim-selamat-datang.png'"
      ></v-img>
      <div v-if="item.is_new" class="ribbon ribbon-top-right"><span>BARU</span></div>
    </div>

    <div></div>

    <v-card-actions class="mt-auto">
      <pre></pre>
      <v-row no-gutters class="pb-4">
        <v-col cols="12">
          <v-btn :id="`jadwal` + item.kode" class="mb-4" v-if="isKelola" depressed rounded color="primary white--text" @click="$emit('pilih')">
            <v-icon small>mdi-pencil</v-icon> Jadwal
          </v-btn>
          <v-btn
            class="mb-4"
            v-else
            depressed
            rounded
            :color="item.is_tutup ? 'success white--text' : !item.is_rilis && !item.is_tutup ? 'orange white--text' : 'primary white--text'"
            @click="item.is_rilis ? $emit('pilih') : ''"
          >
            {{ item.is_rilis && !item.is_tutup ? "Selengkapnya" : !item.is_rilis && !item.is_tutup ? "Segera Hadir" : "Berakhir" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.box {
  position: relative;
  max-width: 600px;
  width: 90%;
  height: 400px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

/* common */
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  content: "";
  display: block;
  border: 5px solid #aa1b10;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #f44336;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top left*/
.ribbon-top-left {
  top: -10px;
  left: -10px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}

/* top right*/
.ribbon-top-right {
  top: -10px;
  right: -10px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}

/* bottom left*/
.ribbon-bottom-left {
  bottom: -10px;
  left: -10px;
}
.ribbon-bottom-left::before,
.ribbon-bottom-left::after {
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.ribbon-bottom-left::before {
  bottom: 0;
  right: 0;
}
.ribbon-bottom-left::after {
  top: 0;
  left: 0;
}
.ribbon-bottom-left span {
  right: -25px;
  bottom: 30px;
  transform: rotate(225deg);
}

/* bottom right*/
.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}
.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}
.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}
.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}
.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-225deg);
}
.card-non-active {
  filter: grayscale(100%);
  position: absolute;
  bottom: 0;
  right: 0;
}
.card-active {
  filter: grayscale(0%);
}

.v-sheet.v-card {
  -webkit-box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08);
}

.v-sheet.v-card:hover {
  box-shadow: 0px 2px 7px 0px rgb(255 255 255), 0px 7px 20px rgba(0, 0, 0, 0.22);
}
</style>

<script>
// @group Global Component
export default {
  name: "BlockCard",
  inheritAttrs: false,
  data() {
    return {
      more_menu: [
        // eslint-disable-next-lint
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "warning",
          click: (i, o) => this.$emit("edit", o)
          // check: (i, o) => (o.status == 0 && this.current_user.is_super_admin ? true : false)
        }
      ]
    };
  },
  props: {
    // Pilihan format tipe card organisasi atau tampilan card data global
    isReady: {
      type: Boolean,
      default: false
    },
    newSeries: {
      type: Boolean,
      default: false
    },
    isKelola: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    //judul
    title: {
      type: String,
      default: "Title"
    },
    //nilai yang harus diisi jika memilih tampilan card data
    value: {
      type: Number,
      default: 0
    },
    //deskripsi
    desc: {
      type: String,
      default: ""
    },
    //warna card
    color: {
      type: String,
      default: "primary"
    },
    // icon card yang digunakan jika memilih model card data
    icon: {
      type: String,
      default: null
    },
    //logo yang digunakan jika memilih tipe card organisasi
    logo: {
      type: String,
      default: null
    },
    // informasi tambahan
    iconDesc: {
      type: String,
      default: ""
    },
    // progress bar untuk pencapaian
    progressBar: {
      type: String,
      default: "on"
    },
    // nilai progress bar
    progressValue: {
      type: Number,
      default: 10
    },
    // tinggi card
    height: {
      type: Number,
      default: 0
    }
  }
};
</script>
